import { Injectable } from '@angular/core';
import { ApiservicesService } from './apiservices.service';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ResolveService {

  public cookiedata: any = this.cookieService.getAll()['login_user_details'];

  constructor(public apiService: ApiservicesService, private cookieService: CookieService,private route:ActivatedRoute,private router: Router) {}

  resolve(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<any> | Promise<any> | any {


    let reqBody = route?.data?.['requestcondition'];
    const login_user_details_main = this.cookieService.get('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : {}



    if (route.routeConfig?.path == 'tarotcard-edit/:id' || state.url.includes('sharespread')) {
      route.data['requestcondition']['_id'] = route.params['id']
    }

    if (route.routeConfig?.path == 'edit-user/:_id') {
      route.data['requestcondition']['id'] = route.params['_id']
    }
    if (route.routeConfig?.path == 'account-info/:_id') {
      route.data['requestcondition']['id'] = route.params['_id']
    }
    if (route.routeConfig?.path == 'training-category-edit/:_id') {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (route.routeConfig?.path == 'training-lesson-edit/:_id') {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (route.routeConfig?.path == 'quarter-edit/:_id') {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (state.url.includes("admin-dashboard/role/add-role") && route.routeConfig?.path == ':id') {
      route.data['requestcondition']['_id'] = route.params['id']
    }
    if (state.url.includes('/admin-dashboard/training/assignment-edit')) {  
      route.data['requestcondition']['_id'] = route.params['_id']
    }

    if (state.url.includes('/astrologer-dashboard/testimonial/edit-tetimonial') || state.url.includes('/admin-dashboard/testimonial/edit-tetimonial')) {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if(state.url.includes('/blog-manegement/edit')){
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (state.url == '/astrologer-dashboard/testimonial') {
      const login_user_details = this.cookieService.get('login_user_details') ? JSON.parse(this.cookieService.get('login_user_details')) : {}
      route.data['requestcondition']['searchcondition']['requested_by_id'] = login_user_details.userinfo._id
    }
    if (route.routeConfig?.path == 'event-list') {
      route.data['requestcondition']['searchcondition']['userid'] = '6423e01fb32dceb05c4e1682'
    }
    if (state.url.includes('/calendar-management/booked-slots')) {
      route.data['requestcondition']['searchcondition']['userid'] = '6423e01fb32dceb05c4e1682'
    }
    if (state.url.includes('/recorded-session')) {
      route.data['requestcondition']['token'] =  route.queryParams['token']
    }
    if (state.url == '/astrologer-dashboard') {
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
      route.data['requestcondition']['searchcondition']['service_provider'] = userCookie.userinfo._id
    }
    if (route.routeConfig?.path == 'editEvent/:_id') {
      route.data['requestcondition']['id'] = route.params['_id']
    }
    if (state.url.includes('/astrologer-dashboard/profile/view/') || state.url.includes('/profile/') || state.url.includes('/customer-dashboard/profile/view/')) {
      route.data['requestcondition']['unique_name'] = route.params['unique_name']
      if(route.params['id']){
        route.data['requestcondition']['id'] = route.params['id']
      }
    }
    if (state.url.includes('/astrologer-dashboard/profile/edit/')) {
      route.data['requestcondition']['id'] = route.params['_id']
    }
    if (state.url.includes('/admin-dashboard/webiner/edit-webiner') || state.url.includes('/admin-dashboard/webiner/edit-webiner')) {
      route.data['requestcondition']['_id'] = route.params['id']
    }
    if (state.url.includes('/admin-dashboard/package/edit-package') || state.url.includes('/astrologer-dashboard/package/edit-package')) {
      route.data['requestcondition']['_id'] = route.params['id']
    }
    if (state.url.includes('/admin-dashboard/package') || state.url.includes('/astrologer-dashboard/package')) {
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
      route.data['requestcondition']['searchcondition']['added_by'] = userCookie.userinfo._id
    }
    if (state.url.includes('/admin-dashboard/tarot-spreads/edit-tarot-spreads')) {
      route.data['requestcondition']['_id'] = route.params['id']
    }
    if (route.routeConfig?.path == 'quiz-edit/:_id') {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (state.url.includes('admin-dashboard/testimonial/request-testimonial/edit-testimonial') || state.url.includes('admin-dashboard/testimonial/request-testimonial/edit-testimonial')) {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (state.url.includes('admin-dashboard/testimonial/create-testimonial/edit-testimonial') || state.url.includes('admin-dashboard/testimonial/create-testimonial/edit-testimonial')) {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (state.url.includes('/admin-dashboard/social-advo/edit-social-advo') || state.url.includes('/admin-dashboard/social-advo/edit-social-advo')) {
      route.data['requestcondition']['_id'] = route.params['id']
    }
    if (state.url.includes('/admin-dashboard/class_configure/edit-class-configure') || state.url.includes('/admin-dashboard/class_configure/edit-class-configure')) {
      route.data['requestcondition']['_id'] = route.params['id']
    }
    if (state.url.includes('/testimonial/create-testimonial') || state.url.includes('/testimonial/create-testimonial')) {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (state.url.includes('/product/product-category_edit')) {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (state.url.includes('/product/product-management_edit')) {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (state.url.includes('/video-management/edit')) {
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if(state.url.includes("/brod-casting/edit")){
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if(state.url.includes("/perrenial-mandalism/edit-dashboard-content")){
      route.data['requestcondition']['_id'] = route.params['_id']
    }
    if (state.url.includes('/astrologer-dashboard/training-center') || state.url.includes('/admin-dashboard/training/training-center')) {
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
      route.data['requestcondition']['user_id'] = userCookie.userinfo._id ? userCookie.userinfo._id : ''
    }
    if (state.url.includes('/customer-dashboard')) {
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
      route.data['requestcondition']['searchcondition']['user_id'] = userCookie.userinfo._id ? userCookie.userinfo._id : ''
    }
    if (state.url.includes('/forget-password/set-password')) {
      route.data['requestcondition']['username'] = route.queryParams['username']
    }
    if(state.url.includes('/affiate-dashboard')){
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
      route.data['requestcondition']['searchcondition']['related_affiliate_id'] = userCookie.userinfo._id
    }
    if (state.url.includes('/astrologer-dashboard/calendar-management/editEvent')) {
       reqBody['searchcondition']['_id'] = route.params['_id'];
    }
    if (state.url == ('/astrologer-dashboard/testimonial/request-testimonial')) {
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
      if (userCookie.userinfo.user_type === 'is_astrologer') {
        route.data['requestcondition']['searchcondition']['testimonial_for'] = userCookie.userinfo._id ? userCookie.userinfo._id : ''
      }

    }
    if (state.url.includes('/customer-dashboard/social-advo/edit-social-advo') || state.url.includes('/customer-dashboard/social-advo/edit-social-advo')) {
      route.data['requestcondition']['_id'] = route.params['id']
    }
    if (state.url.includes('astrologer-dashboard/testimonial/request-testimonial/edit-testimonial') || state.url.includes('astrologer-dashboard/testimonial/request-testimonial/edit-testimonial')) {
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
      if (userCookie.userinfo.user_type === 'is_astrologer') {
        route.data['requestcondition']['_id'] = route.params['_id']
      }
    }
    if (state.url==("/calender")){
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
       route.data['requestcondition']['searchcondition']['userid'] = userCookie.userinfo.calendar_id ? userCookie.userinfo.calendar_id: ""
    }
    if (state.url==("/perennial-mandalism-dashboard")){
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
      route.data['requestcondition']['user_cognito_id'] = userCookie.userinfo.cognito_user_id? userCookie.userinfo.cognito_user_id: ""
    }
    if (state.url==("/perennial-mandalism-dashboard/additional_member")){
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
       route.data['requestcondition']['user_cognito_id'] = userCookie.userinfo.cognito_user_id? userCookie.userinfo.cognito_user_id: ""
    }
    if (state.url.includes("/perennial-mandalism-dashboard/edit")){
       route.data['requestcondition']['user_cognito_id'] = route.params['_id']
    }
    if(state.url.includes("/calender-of-events/edit-calendar-of-events")){
      route.data['requestcondition']['id'] = route.params['_id']
    }
    if(state.url.includes("astro-terrot-decan-info-add")){
      route.data['requestcondition']['id'] = route.params['_id']
    }
    if(state.url.includes("add-astro-decan-videos-pdfs")){
      route.data['requestcondition']['id'] = route.params['_id']
    }
    if(state.url.includes("gernal-content-add-edit")){
      route.data['requestcondition']['id'] = route.params['_id']
    }

    if(state.url.includes("/mysteryschool-signup")){
      route.data['requestcondition']['_id'] = route.params['_id']
    }

    if(state.url.includes("/diviner/transactions")){
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
       route.data['requestcondition']['searchcondition']['customer_id'] = userCookie.userinfo._id ? userCookie.userinfo._id: ""
    }

    if(state.url == ("/mystery-school-dashboard/training-center")){
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
       route.data['requestcondition']['user_id'] = userCookie.userinfo._id ? userCookie.userinfo._id : ""
    }

    if(state.url == ("/mystery-school-dashboard")){
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
       route.data['requestcondition']['user_id'] = userCookie.userinfo._id ? userCookie.userinfo._id : ""
    }

    if (state.url.includes('/mystery-school-dashboard/training-lessons')) {
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
       route.data['requestcondition']['user_id'] = userCookie.userinfo._id ? userCookie.userinfo._id : ""

    }

    if (route.routeConfig?.path === 'wheel-sign-edit/:_id' || state.url.includes('/wheel-sign/wheel-sign-edit')) {route.data['requestcondition']['id'] = route.params['_id'];}

    if(state.url == ("/divination-certification-dashboard")){
        const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
        route.data['requestcondition']['user_id'] = userCookie.userinfo._id ? userCookie.userinfo._id : ""
      }


    if (state.url.includes('/divination-certification-dashboard/diviner-training-lessons')) {
      const userCookie = JSON.parse(this.cookieService.get('login_user_details'))
      route.data['requestcondition']['user_id'] = userCookie.userinfo._id ? userCookie.userinfo._id : ""
      // route.data['requestcondition']['searchcondition']['category_id'] = route.params['_id']

    }

    return new Promise((resolve, reject) => {

      if (state.url.includes('/astrologer-dashboard/calendar-management/event-list') || state.url.includes('/astrologer-dashboard/calendar-management/booked-slots') || state.url.includes('/astrologer-dashboard/calendar-management/editEvent'))  {
        if (reqBody) {
          this.apiService
            .getHttpDataPostcalendar(route?.data?.['endpoint'], reqBody)
            .subscribe({
              next: (res: any) => {
                return resolve(res)
              },
              error: (error: any) => {
                return reject(error)
              }
            });
        }

      }
      else {
        if (reqBody) {
          if (route?.data?.['crossdomain']) {
            this.apiService.getHttpDataPostWithoutBaseUrl(route?.data?.['endpoint'], reqBody).subscribe({
              next: (res: any) => {
                return resolve(res)
              },
              error: (error: any) => {
                return reject(error)
              }
            });
          }else {
            this.apiService
            .getHttpDataPost(route?.data?.['endpoint'], reqBody)
            .subscribe({
              next: (res: any) => {
                return resolve(res)
              },
              error: (error: any) => {
                return reject(error)
              }
            });
          }
         
        } else {
          this.apiService
            .getHttpData(route?.data?.['endpoint'])
            .subscribe({
              next: (res: any) => {
                return resolve(res)
              },
              error: (error: any) => {
                return reject(error)
              }
            });
        }
      }
    });





  }
}
